import {
  ItemHostConfig,
  HostConfig,
  ENV_NAME,
} from '../../utils/types';

const ORION_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://qa.orion.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  QA: {
    endpoint: 'https://qa.orion.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://orion.col.movistar.es',
    headers: {},
  },
};

const BUCKET_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://qa.cms.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  QA: {
    endpoint: 'https://qa.cms.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://prod.cms.col.movistar.es',
    headers: {},
  },
};

const TELCO_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'http://tehrhadx.serv.dev.dc.es.telefonica:11010',
    headers: {
      timeout: 60000,
    },
  },
  INTE: {
    endpoint: 'https://www.movistar.es.inte',
    headers: {
      timeout: 60000,
    },
  },
  QA: {
    endpoint: 'http://tehrhad5.serv.test.dc.es.telefonica:11010',
    headers: {
      timeout: 60000,
    },
  },
  CERT: {
    endpoint: 'https://www.movistar.es.cert',
    headers: {
      timeout: 60000,
    },
  },
  FARM1: {
    endpoint: 'https://tcolgranja1.es.telefonica',
    headers: {
      timeout: 60000,
    },
  },
  FARM2: {
    endpoint: 'https://tcolgranja2.es.telefonica',
    headers: {
      timeout: 60000,
    },
  },
  PROD: {
    endpoint: 'https://www.movistar.es',
    headers: {
      timeout: 60000,
    },
  },
};

const TGES_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://api.dev.es.telefonica/api/rest/intranet/TGES',
    headers: {
      withCredentials: true,
    },
  },
  QA: {
    endpoint: 'https://api.test.es.telefonica/api/rest/intranet/TGES',
    headers: {
      withCredentials: true,
    },
  },
  FARM1: {
    endpoint: 'https://api.telefonica.es/api/rest/TGESTest',
    headers: {
      withCredentials: true,
    },
  },
  FARM2: {
    endpoint: 'https://api.telefonica.es/api/rest/TGESTest',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://api.telefonica.es/api/rest/TGES',
    headers: {
      withCredentials: true,
    },
  },
};

const INFO_CONTEXTO: ItemHostConfig = {
  DEV: {
    endpoint: 'https://www.movistar.es.inte',
    headers: {},
  },
  QA: {
    endpoint: 'https://www.movistar.es.cert',
    headers: {},
  },
  PROD: {
    endpoint: 'https://www.movistar.es',
    headers: {},
  },
};

const LEGADO_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://col10mgmt.tsm.inet',
    headers: {},
  },
  QA: {
    endpoint: 'https://www.movistar.es.cert',
    headers: {},
  },
  PROD: {
    endpoint: 'https://www.movistar.es',
    headers: {},
  },
};

const CUSTOMIZER_CDN_ENV: ItemHostConfig = {
  DEV: {
    endpoint: 'https://customizer.dev.col.movistar.es',
    headers: {},
  },
  QA: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
    },
  },
};

const CUSTOMIZER_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://customizer-dot-mov-dev15.appspot.com',
    headers: {},
  },
  QA: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
      withCredentials: true,
    },
  },
};

const CATALOGUE_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://qa.catalogue.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  QA: {
    endpoint: 'https://qa.catalogue.col.movistar.es',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://catalogue.col.movistar.es',
    headers: {
      withCredentials: true,
      'content-type': 'application/json',
    },
  },
};

const SECURITY_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://apiseg-intranet.dev.es.telefonica',
    headers: {
      withCredentials: true,
    },
  },
  QA: {
    endpoint: 'https://apiseg-intranet.test.es.telefonica',
    headers: {
      withCredentials: true,
    },
  },
  PROD: {
    endpoint: 'https://apiseg-org.telefonica.es',
    headers: {
      withCredentials: true,
    },
  },
};

const TELCO_FRONT_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://t3-org-ein.dev.es.telefonica',
    headers: {},
  },
  QA: {
    endpoint: 'https://t3-org-ece.test.es.telefonica',
    headers: {},
  },
  PROD: {
    endpoint: 'https://t3.telefonica.es',
    headers: {},
  },
};

const TECALIS_ENVS: ItemHostConfig = {
  DEV: {
    endpoint: 'https://int.ms-movistar.c2c.tecalis.dev/col/',
    headers: {},
  },
  QA: {
    endpoint: 'https://int.ms-movistar.c2c.tecalis.dev/col/',
    headers: {},
  },
  PROD: {
    endpoint: 'https://ms-movistar.c2c.tecalis.com/col/',
    headers: {},
  },
};

export const MAIN_ENV: HostConfig = {
  name: ENV_NAME.PROD,
  host: 'movistar.es',
  custo: CUSTOMIZER_ENVS.PROD,
  custoCdn: CUSTOMIZER_CDN_ENV.PROD,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD,
  legado: LEGADO_ENVS.PROD,
  legadoNoVCM: INFO_CONTEXTO.PROD,
  bucket: BUCKET_ENVS.PROD,
  orion: ORION_ENVS.PROD,
  tges: TGES_ENVS.PROD,
  telcoFront: TELCO_FRONT_ENVS.PROD,
  security: SECURITY_ENVS.PROD,
  tecalis: TECALIS_ENVS.PROD,
};

export const ENV_URLS: Array<HostConfig> = [
  {
    name: ENV_NAME.QA,
    host: 'col10mgmt.tsm.inet',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.QA,
    telco: TELCO_ENVS.QA,
    legado: LEGADO_ENVS.DEV,
    legadoNoVCM: INFO_CONTEXTO.QA,
    bucket: BUCKET_ENVS.QA,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.QA,
    telcoFront: TELCO_FRONT_ENVS.QA,
    security: SECURITY_ENVS.QA,
    tecalis: TECALIS_ENVS.QA,
  },
  {
    name: ENV_NAME.QA,
    host: 'www.movistar.es.inte',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.QA,
    telco: TELCO_ENVS.INTE,
    legado: LEGADO_ENVS.QA,
    legadoNoVCM: INFO_CONTEXTO.DEV,
    bucket: BUCKET_ENVS.QA,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.DEV,
    telcoFront: TELCO_FRONT_ENVS.DEV,
    security: SECURITY_ENVS.DEV,
    tecalis: TECALIS_ENVS.QA,
  },
  {
    name: ENV_NAME.QA,
    host: 'www.movistar.es.cert',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.QA,
    telco: TELCO_ENVS.CERT,
    legado: LEGADO_ENVS.QA,
    legadoNoVCM: INFO_CONTEXTO.QA,
    bucket: BUCKET_ENVS.QA,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.QA,
    telcoFront: TELCO_FRONT_ENVS.QA,
    security: SECURITY_ENVS.QA,
    tecalis: TECALIS_ENVS.QA,
  },
  {
    name: ENV_NAME.QA,
    host: 'qa.cms.col.movistar.es',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.QA,
    telco: TELCO_ENVS.QA,
    legado: LEGADO_ENVS.QA,
    legadoNoVCM: INFO_CONTEXTO.QA,
    bucket: BUCKET_ENVS.QA,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.QA,
    telcoFront: TELCO_FRONT_ENVS.QA,
    security: SECURITY_ENVS.QA,
    tecalis: TECALIS_ENVS.QA,
  },
  {
    name: ENV_NAME.QA,
    host: 'tcolgranja1.es.telefonica',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.PROD,
    telco: TELCO_ENVS.FARM1,
    legado: LEGADO_ENVS.QA,
    legadoNoVCM: INFO_CONTEXTO.PROD,
    bucket: BUCKET_ENVS.QA,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.FARM1,
    telcoFront: TELCO_FRONT_ENVS.PROD,
    security: SECURITY_ENVS.PROD,
    tecalis: TECALIS_ENVS.PROD,
  },
  {
    name: ENV_NAME.QA,
    host: 'tcolgranja2.es.telefonica',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.PROD,
    telco: TELCO_ENVS.FARM2,
    legado: LEGADO_ENVS.QA,
    legadoNoVCM: INFO_CONTEXTO.PROD,
    bucket: BUCKET_ENVS.QA,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.FARM2,
    telcoFront: TELCO_FRONT_ENVS.PROD,
    security: SECURITY_ENVS.PROD,
    tecalis: TECALIS_ENVS.PROD,
  },
  {
    name: ENV_NAME.DEV,
    host: '127.0.0.1',
    custo: CUSTOMIZER_ENVS.QA,
    custoCdn: CUSTOMIZER_CDN_ENV.QA,
    catalogue: CATALOGUE_ENVS.QA,
    telco: TELCO_ENVS.QA,
    legado: LEGADO_ENVS.DEV,
    legadoNoVCM: INFO_CONTEXTO.PROD,
    bucket: BUCKET_ENVS.PROD,
    orion: ORION_ENVS.QA,
    tges: TGES_ENVS.QA,
    telcoFront: TELCO_FRONT_ENVS.QA,
    security: SECURITY_ENVS.QA,
    tecalis: TECALIS_ENVS.QA,
  },
  MAIN_ENV,
  {
    name: ENV_NAME.PROD,
    host: 'prod.cms.col.movistar.es',
    custo: CUSTOMIZER_ENVS.PROD,
    custoCdn: CUSTOMIZER_CDN_ENV.PROD,
    catalogue: CATALOGUE_ENVS.PROD,
    telco: TELCO_ENVS.PROD,
    legado: LEGADO_ENVS.PROD,
    legadoNoVCM: INFO_CONTEXTO.PROD,
    bucket: BUCKET_ENVS.PROD,
    orion: ORION_ENVS.PROD,
    tges: TGES_ENVS.PROD,
    telcoFront: TELCO_FRONT_ENVS.PROD,
    security: SECURITY_ENVS.PROD,
    tecalis: TECALIS_ENVS.PROD,
  },
  {
    name: ENV_NAME.PROD,
    host: 'atencionalcliente.movistar.es',
    custo: CUSTOMIZER_ENVS.PROD,
    custoCdn: CUSTOMIZER_CDN_ENV.PROD,
    catalogue: CATALOGUE_ENVS.PROD,
    telco: TELCO_ENVS.PROD,
    legado: LEGADO_ENVS.PROD,
    legadoNoVCM: INFO_CONTEXTO.PROD,
    bucket: BUCKET_ENVS.PROD,
    orion: ORION_ENVS.PROD,
    tges: TGES_ENVS.PROD,
    telcoFront: TELCO_FRONT_ENVS.PROD,
    security: SECURITY_ENVS.PROD,
    tecalis: TECALIS_ENVS.PROD,
  },
  {
    name: ENV_NAME.PROD,
    host: 'web.movistar.es',
    custo: CUSTOMIZER_ENVS.PROD,
    custoCdn: CUSTOMIZER_CDN_ENV.PROD,
    catalogue: CATALOGUE_ENVS.PROD,
    telco: TELCO_ENVS.PROD,
    legado: LEGADO_ENVS.PROD,
    legadoNoVCM: INFO_CONTEXTO.PROD,
    bucket: BUCKET_ENVS.PROD,
    orion: ORION_ENVS.PROD,
    tges: TGES_ENVS.PROD,
    telcoFront: TELCO_FRONT_ENVS.PROD,
    security: SECURITY_ENVS.PROD,
    tecalis: TECALIS_ENVS.PROD,
  },
];

const DEFAULT_LOCATION_BY_ENV_NAME = {
  [ENV_NAME.DEV]: '127.0.0.1',
  [ENV_NAME.QA]: 'qa.cms.col.movistar.es',
  [ENV_NAME.PROD]: 'movistar.es',
};

export const findOutEnvByHost = (envName: string): HostConfig => {
  let selectedHost = DEFAULT_LOCATION_BY_ENV_NAME[envName];
  if (!selectedHost) {
    console.warn('envName no tipado');
    selectedHost = 'movistar.es';
  }

  return ENV_URLS.find((item) => item.host === selectedHost) || MAIN_ENV;
};

export const findOutEnv = (defaultHost = 'movistar.es'): HostConfig => {
  let res: HostConfig =
    ENV_URLS.find((item) => item.host === defaultHost) || MAIN_ENV;
  try {
    const myUrl: string = document.location.href;
    const item = ENV_URLS.find((envUrl) => {
      const { host } = envUrl;
      return myUrl.indexOf(host) !== -1;
    });

    if (item) {
      res = item;
    }
  } catch (err) {
    return res;
  }

  return res;
};

export const howAppIsRunning = (): string => {
  const { NODE_ENV } = process.env;
  return NODE_ENV || '';
};
